import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { SuspendCardStackRoutes, SuspendCardStackScreenProps } from './type';
import { SuspendCardWebZeroScreen } from './SuspendCardWebZero.screen';
import { SuspendCardNativeZeroScreen } from './SuspendCardNativeZero.screen';

export interface SuspendCardProps {}
export const SuspendCardConfirm: React.FC<SuspendCardStackScreenProps<SuspendCardStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, account, tab, record, func, actionResponse, actionError, onData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});

  if (layout.isMobile) {
    return (
      <SuspendCardNativeZeroScreen
        onClose={onGoBack}
        account={account}
        tab={tab}
        record={record}
        func={func}
        actionResponse={actionResponse}
        actionError={actionError}
        onData={onData}
        refresh={refresh}
      />
    );
  }

  return (
    <SuspendCardWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      record={record}
      func={func}
      actionResponse={actionResponse}
      actionError={actionError}
      onData={onData}
      refresh={refresh}
    />
  );
};
